import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "cart-page-body"
};
const _hoisted_2 = {
  class: "cart-page-left"
};
const _hoisted_3 = {
  class: "cart-page-left-alerts"
};
const _hoisted_4 = {
  class: "cart-page-left-address"
};
const _hoisted_5 = {
  class: "header-po-wrapper"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["aria-label", "disabled"];
const _hoisted_8 = {
  class: "cart-page-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CartAlertBox = _resolveComponent("CartAlertBox");
  const _component_AddressBox = _resolveComponent("AddressBox");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_OrderSummary = _resolveComponent("OrderSummary");
  const _component_CartItem = _resolveComponent("CartItem");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.hasPopulatedPOs ? (_openBlock(), _createBlock(_component_CartAlertBox, {
    key: 0,
    cartData: $props.cartData,
    unableToComplete: $props.apiCallFailure || $data.isEmptyCartError || $data.isSaveFailure,
    poError: $options.poError
  }, null, 8, ["cartData", "unableToComplete", "poError"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_AddressBox, {
    "has-forwarding-agent": $options.hasForwardingAgent
  }, null, 8, ["has-forwarding-agent"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, [_createElementVNode("span", {
    innerHTML: $options.getI18nMessage('quickOrder.applyPo')
  }, null, 8, _hoisted_6), _createVNode(_component_Tooltip, {
    class: "tabs-tooltip",
    passedText: $options.getI18nMessage('quickOrder.PONumber.enterPONumber')
  }, null, 8, ["passedText"])]), _withDirectives(_createElementVNode("input", {
    class: _normalizeClass({
      'disabled': $options.isHeaderPODisabled
    }),
    maxlength: "35",
    "aria-label": $options.getI18nMessage('checkout.payment.PONumber.enterPONumber'),
    tabindex: "0",
    type: "text",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.cartData.cartData.purchaseOrderNumber = $event),
    onBlur: _cache[1] || (_cache[1] = (...args) => $options.updateHeaderPO && $options.updateHeaderPO(...args)),
    disabled: $options.isHeaderPODisabled
  }, null, 42, _hoisted_7), [[_vModelText, $props.cartData.cartData.purchaseOrderNumber]])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_OrderSummary, {
    onEmptyCartFailure: $options.emptyCartFailure,
    onSaveFailure: $options.saveFailure,
    onUpdateEntries: $options.updateEntries,
    removeMessage: $options.getI18nMessage('cart.page.emptyCart.popup.message'),
    isButtonDisabled: $options.isCheckoutDisabled(),
    cartData: $props.cartData,
    poNum: $options.getPONum(),
    onCheckoutClicked: $options.validateItems
  }, null, 8, ["onEmptyCartFailure", "onSaveFailure", "onUpdateEntries", "removeMessage", "isButtonDisabled", "cartData", "poNum", "onCheckoutClicked"])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cartEntries, (cartEntry, index) => {
    return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_CartItem, {
      onShowRemoveItemModal: $event => $options.emitRemoveItemModal(cartEntry),
      itemData: cartEntry,
      isMultiPo: $data.isMultiPO,
      isUnconfiguredEntry: $options.isUnconfiguredEntry(cartEntry),
      isNeedEditEntry: $options.isNeedEditEntry(cartEntry),
      isNeedRemoveEntry: $options.isNeedRemoveEntry(cartEntry),
      onCartDataUpdated: $options.updateCartData,
      onSaveFailure: $options.saveFailure
    }, null, 8, ["onShowRemoveItemModal", "itemData", "isMultiPo", "isUnconfiguredEntry", "isNeedEditEntry", "isNeedRemoveEntry", "onCartDataUpdated", "onSaveFailure"])]);
  }), 256))], 64);
}